import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const EventRegistrationDetailsSlice = createApi({
  reducerPath: "eventRegistrationDetailsSlice",
  baseQuery: customBaseQuery,
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  refetchOnFocus: true,
  endpoints: (builder) => ({
    getEventRegistrationDetails: builder.query({
      query: (id) => ({
        url: `/enrollment/${id}?pageSize=2147483647`,
        method: "GET"
      })
    })
  })
});

export const { useGetEventRegistrationDetailsQuery } =
  EventRegistrationDetailsSlice;
